import { render, staticRenderFns } from "./PicosList.vue?vue&type=template&id=66829a37&"
import script from "./PicosList.vue?vue&type=script&lang=js&"
export * from "./PicosList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports